module.exports = __webpack_public_path__ + "static/img/伙伴客户-艾瑞光电.380b13c2.png";